import { decodeSearchParams } from '@elemental/pagination-helpers';

import { DataRecord } from '../redux/data';
import { DataLoadProps } from '../types/pagination';

/**
 * converts encoded querystring to data load options
 */
const routeToDataLoad = (initialDataLoad: DataLoadProps): DataLoadProps => {
  const queryParams = new URLSearchParams(globalThis.location.search);

  const dataLoad = queryParams.get('dataLoad');

  if (!dataLoad) {
    return initialDataLoad;
  }

  const decodedDataLoad = decodeURIComponent(dataLoad);
  const encodedParams = new URLSearchParams(decodedDataLoad);
  const encodedParamsObject = Object.fromEntries(encodedParams.entries());
  const decodedProps = decodeSearchParams<DataRecord>(encodedParamsObject);

  return {
    paginationModel: {
      page: decodedProps.page ?? initialDataLoad.paginationModel.page,
      pageSize:
        decodedProps.per_page ?? initialDataLoad.paginationModel.pageSize,
    },
    sortModel: decodedProps.sort_by
      ? decodedProps.sort_by.map((entry) => ({
          field: entry.column,
          sort: entry.sort_ascending ? 'asc' : 'desc',
        }))
      : initialDataLoad.sortModel,
  };
};

export default routeToDataLoad;
